/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { DatasetPolymorphicConciergeDataset } from './DatasetPolymorphicConciergeDataset';
import {
  DatasetPolymorphicConciergeDatasetFromJSON,
  DatasetPolymorphicConciergeDatasetFromJSONTyped,
  DatasetPolymorphicConciergeDatasetToJSON,
} from './DatasetPolymorphicConciergeDataset';
import type { DatasetPolymorphicConversationalAgentDataset } from './DatasetPolymorphicConversationalAgentDataset';
import {
  DatasetPolymorphicConversationalAgentDatasetFromJSON,
  DatasetPolymorphicConversationalAgentDatasetFromJSONTyped,
  DatasetPolymorphicConversationalAgentDatasetToJSON,
} from './DatasetPolymorphicConversationalAgentDataset';
import type { DatasetPolymorphicInformationExtractionDataset } from './DatasetPolymorphicInformationExtractionDataset';
import {
  DatasetPolymorphicInformationExtractionDatasetFromJSON,
  DatasetPolymorphicInformationExtractionDatasetFromJSONTyped,
  DatasetPolymorphicInformationExtractionDatasetToJSON,
} from './DatasetPolymorphicInformationExtractionDataset';
import type { DatasetPolymorphicSingleTurnChatDataset } from './DatasetPolymorphicSingleTurnChatDataset';
import {
  DatasetPolymorphicSingleTurnChatDatasetFromJSON,
  DatasetPolymorphicSingleTurnChatDatasetFromJSONTyped,
  DatasetPolymorphicSingleTurnChatDatasetToJSON,
} from './DatasetPolymorphicSingleTurnChatDataset';
import type { DatasetPolymorphicTabularMLDataset } from './DatasetPolymorphicTabularMLDataset';
import {
  DatasetPolymorphicTabularMLDatasetFromJSON,
  DatasetPolymorphicTabularMLDatasetFromJSONTyped,
  DatasetPolymorphicTabularMLDatasetToJSON,
} from './DatasetPolymorphicTabularMLDataset';
import type { DatasetPolymorphicTextGenerationDataset } from './DatasetPolymorphicTextGenerationDataset';
import {
  DatasetPolymorphicTextGenerationDatasetFromJSON,
  DatasetPolymorphicTextGenerationDatasetFromJSONTyped,
  DatasetPolymorphicTextGenerationDatasetToJSON,
} from './DatasetPolymorphicTextGenerationDataset';
import type { DatasetPolymorphicVoiceAgentDataset } from './DatasetPolymorphicVoiceAgentDataset';
import {
  DatasetPolymorphicVoiceAgentDatasetFromJSON,
  DatasetPolymorphicVoiceAgentDatasetFromJSONTyped,
  DatasetPolymorphicVoiceAgentDatasetToJSON,
} from './DatasetPolymorphicVoiceAgentDataset';

/**
 * @type DatasetPolymorphic
 *
 * @export
 */
export type DatasetPolymorphic =
  | ({ taskType: 'concierge' } & DatasetPolymorphicConciergeDataset)
  | ({ taskType: 'conversational_agent' } & DatasetPolymorphicConversationalAgentDataset)
  | ({ taskType: 'information_extraction' } & DatasetPolymorphicInformationExtractionDataset)
  | ({ taskType: 'single_turn_chat' } & DatasetPolymorphicSingleTurnChatDataset)
  | ({ taskType: 'tabular_ml' } & DatasetPolymorphicTabularMLDataset)
  | ({ taskType: 'text_generation' } & DatasetPolymorphicTextGenerationDataset)
  | ({ taskType: 'voice_agent' } & DatasetPolymorphicVoiceAgentDataset);

export function DatasetPolymorphicFromJSON(json: any): DatasetPolymorphic {
  return DatasetPolymorphicFromJSONTyped(json, false);
}

export function DatasetPolymorphicFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatasetPolymorphic {
  if (json == null) {
    return json;
  }
  switch (json['task_type']) {
    case 'concierge':
      return Object.assign({}, DatasetPolymorphicConciergeDatasetFromJSONTyped(json, true), {
        taskType: 'concierge',
      } as const);
    case 'conversational_agent':
      return Object.assign({}, DatasetPolymorphicConversationalAgentDatasetFromJSONTyped(json, true), {
        taskType: 'conversational_agent',
      } as const);
    case 'information_extraction':
      return Object.assign({}, DatasetPolymorphicInformationExtractionDatasetFromJSONTyped(json, true), {
        taskType: 'information_extraction',
      } as const);
    case 'single_turn_chat':
      return Object.assign({}, DatasetPolymorphicSingleTurnChatDatasetFromJSONTyped(json, true), {
        taskType: 'single_turn_chat',
      } as const);
    case 'tabular_ml':
      return Object.assign({}, DatasetPolymorphicTabularMLDatasetFromJSONTyped(json, true), {
        taskType: 'tabular_ml',
      } as const);
    case 'text_generation':
      return Object.assign({}, DatasetPolymorphicTextGenerationDatasetFromJSONTyped(json, true), {
        taskType: 'text_generation',
      } as const);
    case 'voice_agent':
      return Object.assign({}, DatasetPolymorphicVoiceAgentDatasetFromJSONTyped(json, true), {
        taskType: 'voice_agent',
      } as const);
    default:
      throw new Error(`No variant of DatasetPolymorphic exists with 'taskType=${json['taskType']}'`);
  }
}

export function DatasetPolymorphicToJSON(value?: DatasetPolymorphic | null): any {
  if (value == null) {
    return value;
  }
  switch (value['taskType']) {
    case 'concierge':
      return DatasetPolymorphicConciergeDatasetToJSON(value);
    case 'conversational_agent':
      return DatasetPolymorphicConversationalAgentDatasetToJSON(value);
    case 'information_extraction':
      return DatasetPolymorphicInformationExtractionDatasetToJSON(value);
    case 'single_turn_chat':
      return DatasetPolymorphicSingleTurnChatDatasetToJSON(value);
    case 'tabular_ml':
      return DatasetPolymorphicTabularMLDatasetToJSON(value);
    case 'text_generation':
      return DatasetPolymorphicTextGenerationDatasetToJSON(value);
    case 'voice_agent':
      return DatasetPolymorphicVoiceAgentDatasetToJSON(value);
    default:
      throw new Error(`No variant of DatasetPolymorphic exists with 'taskType=${value['taskType']}'`);
  }
}
